import { Grid } from '@mui/material';
import type { ConfirmationCode, Username } from '@vy/types';
import { raiseUnreachable } from '@vy/utils';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useVyStepper } from '../../../hooks/use-vy-stepper';
import { AuthBackgroundImage } from '../users-components/AuthBackgroundImage';
import { PasswordResetSuccessMessage } from './reset-password-components/PasswordResetSuccessMessage';
import { RequestPasswordResetForm } from './reset-password-components/reset-password-steps-forms/RequestPasswordResetForm';
import { ResetPasswordForm } from './reset-password-components/reset-password-steps-forms/ResetPasswordForm';
import { VerifyCodeForm } from './reset-password-components/reset-password-steps-forms/VerifyCodeForm';
import { PasswordResetSteps } from './reset-password-consts/password-reset-steps';
import type { PasswordResetStep } from './reset-password-consts/password-reset-steps';

export const ResetPasswordPage: React.FC = () => {
  const [email, setEmail] = useState<Username>('');
  const [verificationCode, setVerificationCode] = useState<ConfirmationCode>('');
  const { currentStep, nextStep } = useVyStepper<PasswordResetStep>(
    PasswordResetSteps.REQUEST,
    PasswordResetSteps,
  );

  const handleEmailSubmission = (emailInput: Username) => {
    setEmail(emailInput);
    nextStep();
  };

  const handleCodeSubmission = (code: ConfirmationCode) => {
    setVerificationCode(code);
    nextStep();
  };

  const renderStepContent = (step: PasswordResetStep) => {
    switch (step) {
      case PasswordResetSteps.REQUEST:
        return <RequestPasswordResetForm onNext={handleEmailSubmission} />;
      case PasswordResetSteps.VERIFY:
        return <VerifyCodeForm onNext={handleCodeSubmission} />;
      case PasswordResetSteps.RESET:
        return <ResetPasswordForm email={email} verificationCode={verificationCode} onNext={nextStep} />;
      case PasswordResetSteps.COMPLETED:
        return <PasswordResetSuccessMessage />;
      default:
        return raiseUnreachable(step);
    }
  };

  return (
    <>
      <Helmet>
        <title>Reset Password</title>
      </Helmet>
      <Grid container style={{ height: '100vh', overflow: 'hidden' }}>
        <Grid
          size={{
            lg: 5
          }}
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }}>
          {renderStepContent(currentStep)}
        </Grid>
        <AuthBackgroundImage />
      </Grid>
    </>
  );
};
